// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { localize } from 'i18n-calypso'

class Footer extends React.Component {
	render() {
		const { translate, homeUrl, siteFullName, locationAddress, userIsLoggedIn, locale, facebookURL, youtubeURL, currentYear } = this.props
		let logoLocale = locale

		if ( 'ca' == locale ) {
			logoLocale = 'es'
		}

		const textBy = translate( 'Copyright &copy; %(currentYear)s %(site_name)s', {
			args: {
				currentYear: currentYear,
				site_name: siteFullName
			}
		} )

		const signInUrl = `/signin?redirect_to=${window.location.href}`
		const signOutUrl = `/signout?redirect_to=${window.location.href}`

		let sdaLogoUrl = `${siteData.logo_full_tight_base_url}night.svg`
		sdaLogoUrl = sdaLogoUrl.replace( /\/adventist-(..)-/gm, `/adventist-${logoLocale}-` )

		return (
			<footer className="footer">
				<div className="-inner">
					<div className="-content">
						<div className="-a">
							{/* ( facebookURL || youtubeURL ) &&
								<div className="-social">
									{ facebookURL &&
										<a className="-social-facebook" href={ facebookURL } target="_blank" rel="noopener">
											<i className="icon-facebook" aria-hidden="true"></i>
											<span className="u-screen-reader-text">Facebook</span>
										</a>
									}

									{ youtubeURL &&
										<a className="-social-youtube" href={ youtubeURL } target="_blank" rel="noopener">
											<i className="icon-youtube-play" aria-hidden="true"></i>
											<span className="u-screen-reader-text">YouTube</span>
										</a>
									}
								</div>
							*/}

							{ ( siteData.location_address || siteData.phone ) &&
								<p>
									{ siteFullName }<br />
									{ siteData.location_address &&
										<span dangerouslySetInnerHTML={ { __html: locationAddress } } />
									}

									{ ( siteData.location_address && siteData.phone ) && <br /> }

									{ siteData.phone &&
										<span>{ siteData.phone }</span>
									}
								</p>
							}

							<p>
								<span dangerouslySetInnerHTML={ { __html: textBy } } />
								<br />
								{ translate( 'Website by' ) } <a href="https://alexgreendesign.com" target="_blank" rel="noopener">Alex Green Design</a>
								<br />

								{ userIsLoggedIn &&
									<a href={ signOutUrl }>{ translate( 'Log out' ) }</a>
								||
									<a href={ signInUrl }>{ translate( 'Log in' ) }</a>
								}
							</p>
						</div>

						<div className="-b">
							<a className="-logo-adventist" href={ homeUrl }>
								<img src={ sdaLogoUrl } alt="Seventh-day Adventist Church" />
							</a>
						</div>
					</div>
				</div>
			</footer>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		homeUrl: state.site.homeUrl,
		siteFullName: state.site.siteFullName,
		locationAddress: state.site.locationAddress,
		facebookURL: state.site.facebookURL,
		youtubeURL: state.site.youtubeURL,
		userIsLoggedIn: state.site.userIsLoggedIn,
		locale: state.site.locale,
		currentYear: state.site.currentYear
	}
}

export default localize(
	connect( mapStateToProps )( Footer )
)
